import React, { createContext, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { ConfirmDialog } from "../components";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => {}); // Initialize as a no-op function
  const [confirmOptions, setConfirmOptions] = useState({});

  const openSnackbar = (message, severity) => {
    if (message) {
      setMessage(message);
    }
    if (severity) {
      setSeverity(severity);
    }
    setShowSnackbar(true);
  };

  const closeSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return; // Prevent closing on clickaway
    }
    setShowSnackbar(false);
  };

  const openConfirmDialog = (message, confirmCallback, options = {}) => {
    setConfirmMessage(message);
    setOnConfirm(() => confirmCallback); // Wrap callback in a function
    setConfirmOptions(options);
    setShowConfirmDialog(true);
  };

  const closeConfirmDialog = () => {
    setShowConfirmDialog(false);
    setConfirmMessage("");
    setConfirmOptions({});
    setOnConfirm(() => () => {}); // Reset to no-op
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar, openSnackbar, closeSnackbar, openConfirmDialog }}>
      <Snackbar 
        open={showSnackbar} 
        autoHideDuration={4000} 
        onClose={closeSnackbar} 
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={severity}
          onClose={closeSnackbar}
          sx={{
            boxShadow: 'none',
            border: '1px solid currentColor',
          }}
        >
          {message}
        </Alert>
      </Snackbar>
      <ConfirmDialog 
        message={confirmMessage} 
        onConfirm={onConfirm} 
        showDialog={showConfirmDialog} // Consistent prop name
        onClose={closeConfirmDialog} // Use closeConfirmDialog
        {...confirmOptions}
      />
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarContext;
